import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

function Hero() {
  const navigate = useNavigate();

  useEffect(() => {
    // Floating particles annimation
    const container = document.getElementById("hero-particles");
    if (!container) return;

    const colors = ["#FF6B00", "#FF9A3C", "#FF8C30", "#ffffff"];

    const interval = setInterval(() => {
      const particle = document.createElement("div");
      particle.className = "particle";

      const size = Math.random() * 6 + 2;
      const duration = 2.5 + Math.random() * 3;

      particle.style.cssText = `
                position: absolute;
                width: ${size}px;
                height: ${size}px;
                left: ${Math.random() * 100}%;
                bottom: ${5 + Math.random() * 50}%;
                background: ${colors[Math.floor(Math.random() * colors.length)]};
                animation: particleFloat ${duration}s linear infinite;
                opacity: ${0.08 + Math.random() * 0.3};
                border-radius: 50%;
            `;

      container.appendChild(particle);
      setTimeout(() => particle.remove(), (duration + 1) * 1000);
    }, 250);

    return () => clearInterval(interval);
  }, []);

  return (
    <section className="min-h-screen flex flex-col items-center justify-center relative overflow-hidden px-6 pt-24 pb-16 text-center">
      {/*Animated Grid Background*/}
      <div
        className="absolute inset-0 opacity-50 animate-grid-pulse"
        style={{
          backgroundImage:
            "linear-gradient(#222 1px, transparent 1px ), linear-gradient(90deg, #222 1px, transparent 1px)",
          backgroundSize: "80px 80px",
          maskImage:
            "radial-gradient(ellipse 70% 70% at 50% 50%, black,transparent)",
        }}
      />

      {/* Glowing Orb */}
      <div
        className="absolute w-[500px] h-[500px] top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 pointer-events-none animate-orb-pulse"
        style={{
          background:
            "radial-gradient(circle, rgba(255, 107, 0, 0.07) 0%, transparent 65%)",
        }}
      />

      {/* Floating Particles Container */}
      <div
        id="hero-particles"
        className="absolute inset-0 pointer-events-none"
      />

      {/* Content */}
      <div className="relative z-10 max-w-4xl">
        {/* CreatorOS Title */}
        <div
          className="font-space text-[clamp(40px,6vw,80px)] tracking-[2px] mb-0 opacity-0"
          style={{
            color: '#FF6B00',
            animation: "fadeUp 0.8s ease 0.2s forwards",
            fontWeight: '800',
          }}
        >
          # CreatorOS 0.01
        </div>

        {/* Main title */}
        <h1
          className="font-space text-[clamp(28px,4vw,52px)] leading-none tracking-[2px] mb-0 opacity-0"
          style={{
            animation: "fadeUp 1s ease 0.3s forwards",
            fontWeight: '700',
          }}
        >
          <span className="block text-text-primary">Turn Long Videos into</span>
          <span className="block text-text-primary">Viral Highlights in Seconds</span>
        </h1>

        {/* Upload Button */}
        <div
          className="flex gap-3.5 justify-center mt-[52px] mb-20 opacity-0"
          style={{
            animation: "fadeUp 1s ease 0.7s forwards",
          }}
        >
          <button
            onClick={() => {
              navigate("/upload");
            }}
            style={{ backgroundColor: '#FF6B00', fontWeight: '700' }}
            className="text-black font-space text-[11px] tracking-[3px] px-9 py-3.5 no-underline uppercase transition-all duration-200 hover:opacity-90 hover:-translate-y-0.5"
          >
            Upload Video
          </button>
        </div>
      </div>
    </section>
  );
}

export default Hero;
